import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MainLoader from './components/MainLoader';
import ImprezyAdmin from './views/admin/ImprezyAdmin';
import Imprezy from './views/Imprezy';
import KonkursyAdmin from './views/admin/KonkursyAdmin';
import { api } from './service/Api';

const components = {
  ImprezyAdmin,
  Imprezy,
  KonkursyAdmin
};

const rootElement = document.getElementById('react-root');
if (rootElement) {
  const viewName = rootElement.getAttribute('data-view');
  const csrf = rootElement.getAttribute('data-csrf');
  api.setCsrf(csrf);
  const content = { csrf }
  const Component = components[viewName];
  if (Component) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Suspense fallback={<MainLoader/>}>
        <Component {...content} />
      </Suspense>
    );
  } else {
    console.error(`Komponent dla widoku "${viewName}" nie został znaleziony.`);
  }
}
